import { createThemeFromJson } from "./utils/createThemeFromJson"
import jsonTheme from "./variables.json"

export const theme = createThemeFromJson(jsonTheme)

export const globalStyles = {
    "input::-ms-reveal, input::-ms-clear": {
        display: "none",
    },
}
